module.exports = __webpack_public_path__ + "img/appltCourse-img27.652a2fe6.png";